import * as React from "react"
import { useTogglePreviewBuilds } from "../hooks/useTogglePreviewBuilds"
import { sitePreviewSettings as text } from "@modules/locales/default.js"
import { ToggleCheckbox, Spacer, Link } from "gatsby-interface"
import { MdInfoOutline } from "react-icons/md"

export type EnablePreviewBuildsProps = {
  siteId: string
  previewBuildsEnabled: boolean
  disabled?: boolean
}

export function EnablePreviewBuilds({
  siteId,
  previewBuildsEnabled,
  disabled,
}: EnablePreviewBuildsProps) {
  const [togglePreviewBuilds, { errorAlert }] = useTogglePreviewBuilds(siteId)

  return (
    <React.Fragment>
      <ToggleCheckbox
        id="enable-preview-builds-checkbox"
        label={
          <React.Fragment>
            {text.labels.enablePreviewBuilds}
            <Spacer direction="horizontal" size={3} />
            <Link
              href={`https://gatsby.dev/site-settings-enable-cms-preview-builds-info`}
              title={text.labels.learnAboutCmsPreviewBuilds}
            >
              <MdInfoOutline />
            </Link>
          </React.Fragment>
        }
        hint={text.messages.runsBuildsForContentChanges}
        checked={!!previewBuildsEnabled}
        onChange={() => {
          togglePreviewBuilds()
        }}
        disabled={disabled}
      />
      {errorAlert}
    </React.Fragment>
  )
}
